import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  contentWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10
  },
    container: {
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',

    [theme.breakpoints.down('sm')]: {
      padding: '16px 0 80px'
    }
  },
  header: {
    width: '100%',
    marginBottom: 32
  },
  promoImg: {
    width: '100%',
    borderRadius: 16,
    marginTop: 16,
    display: 'block',

    [theme.breakpoints.down('sm')]: {
      height: 120
    },
    [theme.breakpoints.down('xs')]: {
      height: 90
    }
  },
  pageTitle: {
    fontSize: '2rem',
    fontWeight: 700,
    marginBottom: 24,
    lineHeight: 1.3,
    color: theme.palette.text.primary,

    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem'
    }
  }
}))
